import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import MainApp from './ui/MainApp';
import TermsAndConditions from './ui/TermsAndConditions';
import SurveyAssigned from './ui/SurveyAssigned';
import * as Constants from './constants';
import './App.css';

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path={`${Constants.PATHS.TERMS_AND_CONDITIONS}`} render={props => <TermsAndConditions />} />
        <Route path={`${Constants.PATHS.SURVEY_ASSIGNED}`} render={props => <SurveyAssigned props={props} />} />
        <Route path={`${Constants.PATHS.HOME}`} render={props => <MainApp />} />
      </Switch>
    </div>
  );
}

export default withRouter(App);
